export default __webpack_public_path__ + "static/media/carousel-previous-btn.1fedd9d6.svg";